import DocumentsPage from "@/components/DocumentsPage";

export default function PortalDocuments() {
  return (
    <DocumentsPage
      accent="blue"
      eyebrow="Clinic · Documents"
      title="Document registry"
      description="Track agreements, disclaimers, and compliance paperwork between your clinic and the Nodera network."
    />
  );
}
